import { AxiosGet } from "../useApi";

export function GetRoles() {
    const route = 'user-role';
    return AxiosGet(route)
}

export function GetRole(params) {
    const route = 'user-role/by-id';
    return AxiosGet(route, params)
}